import { ReactElement } from 'react';
import { Badge, BadgeProps, Body1, makeStyles, tokens } from '@fluentui/react-components';
import { CheckmarkCircleRegular, CircleRegular, PersonRegular, SubtractCircleRegular } from '@fluentui/react-icons';

import { STATUS_LABEL } from '../../constants';
import { TFindingStatus } from '../../types';

const STATUS_META: Record<TFindingStatus, { color: BadgeProps['color']; icon: ReactElement }> = {
  unresolved: { color: 'subtle', icon: <CircleRegular /> },
  assigned: { color: 'brand', icon: <PersonRegular /> },
  dismissed: { color: 'subtle', icon: <SubtractCircleRegular /> },
  resolved: { color: 'success', icon: <CheckmarkCircleRegular /> },
};

type TProps = {
  status: TFindingStatus;
  size?: BadgeProps['size'];
};

const useStyles = makeStyles({
  neutral: {
    color: tokens.colorNeutralForeground2,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
});

export const FindingStatusBadge = ({ status, size = 'medium' }: TProps) => {
  const classes = useStyles();
  const meta = STATUS_META[status] ?? STATUS_META.unresolved;
  return (
    <Badge
      appearance="outline"
      color={meta.color}
      size={size}
      icon={meta.icon}
      className={meta.color === 'subtle' ? classes.neutral : undefined}
    >
      <Body1>{STATUS_LABEL[status] ?? status}</Body1>
    </Badge>
  );
};
